import { render } from "./ApiEvents.vue?vue&type=template&id=05f46f1a&scoped=true"
import script from "./ApiEvents.vue?vue&type=script&lang=js"
export * from "./ApiEvents.vue?vue&type=script&lang=js"

import "./ApiEvents.vue?vue&type=style&index=0&id=05f46f1a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f46f1a"]])

export default __exports__